import { IState } from '../../../store';

export const selectOfferPriceRub = (state: IState): number => {
  const { bargainTerms } = state.offerData.offer;

  return bargainTerms.prices.rur;
};
